export default __webpack_public_path__ + "ec842b14100b28f4421c765a888b6637.woff";